export default {
    name: 'ukCol',

    data() {
        return {
            showWidth: 200
        }
    },

    props: {
        span: {
            type: Number,
            default: 24
        },
        tag: {
            type: String,
            default: 'div'
        },
        offset: Number,
        pull: Number,
        push: Number,
        xs: [Number, Object],
        sm: [Number, Object],
        md: [Number, Object],
        lg: [Number, Object],
        xl: [Number, Object]
    },

    computed: {
        gutter() {
            let parent = this.getParent();
            return parent ? parent.gutter : 0;
        }
    },
    mounted() {
        this.getClientWidth();
    },
    methods: {
        getClientWidth() {
            let parent = this.getParent();
            let clientWidth = parent.$el.clientWidth;
            let gutter = this.gutter || 0;
            this.showWidth = parseInt(clientWidth / parseInt(clientWidth / (parent.minwidth + gutter)) - gutter);
        },
        getParent() {
            let parent = this.$parent;
            while (parent && parent.$options.componentName !== 'ukRow') {
                parent = parent.$parent;
            }

            return parent;
        }
    },
    render(h) {
        let style = {};

        if (this.gutter) {
            style.paddingLeft = this.gutter / 2 + 'px';
            style.paddingRight = style.paddingLeft;
        }
        style.width = this.showWidth + 'px';
        style.display = 'inline-block';

        window.addEventListener('resize', this.getClientWidth);

        return h(this.tag, {
            class: ['el-col'],
            style
        }, this.$slots.default);
    }
};


// WEBPACK FOOTER //
// ./packages/uk-col/src/uk-col.js